import { useMemo } from 'react'

import { dataStructure } from 'syft-acp-core/entities/WorkerDetail/structure'
import { WorkerMarketingPreferencesEntity } from 'syft-acp-core/store/workerMarketingPreferences/types'

/**
 * Returns the data structure for the marketing preference fields, disabling preferences if being updated.
 *
 * The WhatsApp preference is only shown when flex-core actually returns it, so ACP and flex-core can
 * deploy independently — before the back end change lands the row is simply omitted.
 *
 * @param isUpdating
 * @param preferences The worker's current marketing preferences, used to detect optional fields
 * @returns Field structure to be used by EditableTable
 */
export const useGetFieldsSectionStructure = (
  isUpdating: boolean,
  preferences?: WorkerMarketingPreferencesEntity,
) => {
  return useMemo(() => {
    const structure = dataStructure.marketingPreferences.filter(
      ([preference]) =>
        preference !== 'marketing_whatsapp_consent' ||
        (preferences != null && 'marketing_whatsapp_consent' in preferences),
    )

    if (!isUpdating) return structure

    return structure.map(preferenceStructure => [
      preferenceStructure[0],
      {
        ...preferenceStructure[1],
        editable: false,
      },
    ])
  }, [isUpdating, preferences])
}
